import url from "url";
import $ from "jquery";

export default {
    isExternalLink,
    openExternalLinkModal
};

//////////

function isExternalLink( linkElement, documentContext=document ) {

    const href = linkElement.getAttribute('href');

    if(!href || (linkElement.tagName !== 'A')) {
        return false;
    }

    const hrefObj = url.parse(href);

    if( !hrefObj.hostname || (documentContext.location.hostname === hrefObj.hostname || hrefObj.protocol === 'mailto:') || ['handsonbanking.org', 'getmoneyready.wf.com', 'wellsfargo.com', 'www.wellsfargo.com'].indexOf(hrefObj.hostname) !== -1 ) {
        return false;
    }

    return true;

}

function openExternalLinkModal( url ) {

    const $modal = $('#external-link-modal');

    $('#external-link-text').attr('href', url).text(url);
    $modal.find('a.external-link').attr('href', url);
    $modal.foundation('open');

}


// WEBPACK FOOTER //
// ./src/external-links.js